(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qeltro-product-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function parseConfig(root) {
    var node = root.querySelector('[data-pc-pb-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function initBuilder(root) {
    if (!root || root.dataset.pcPbReady === 'true') return;
    root.dataset.pcPbReady = 'true';

    var config = parseConfig(root);
    if (!config) return;

    var controller = new AbortController();
    var signal = controller.signal;
    root._pcPbController = controller;

    var variants = Array.isArray(config.variants) ? config.variants : [];
    var currentVariant = variants.find(function (variant) { return Number(variant.id) === Number(config.initialVariantId); }) || variants[0] || null;
    var selectedOptions = currentVariant ? currentVariant.options.slice() : [];
    var selectedQuantity = 1;
    var selectedBundle = 2;
    var selectedBundleVariantIds = Array(5).fill(currentVariant ? currentVariant.id : 0);
    var bundleWrap = root.querySelector('[data-pc-pb-bundles]');
    var bundleCards = Array.from(root.querySelectorAll('[data-pc-pb-bundle-card]'));
    var bundleSelects = Array.from(root.querySelectorAll('[data-pc-pb-bundle-variant]'));
    var discountPercent = bundleWrap ? Math.max(0, Math.min(100, Number(bundleWrap.dataset.discountPercent || 50))) : 0;
    var activeSlide = 0;

    var slides = Array.from(root.querySelectorAll('[data-pc-pb-slide]'));
    var thumbs = Array.from(root.querySelectorAll('[data-pc-pb-thumb]'));
    var count = root.querySelector('[data-pc-pb-count]');
    var slidesWrap = root.querySelector('[data-pc-pb-slides]');
    var price = root.querySelector('[data-pc-pb-price]');
    var compare = root.querySelector('[data-pc-pb-compare]');
    var sale = root.querySelector('[data-pc-pb-sale]');
    var stock = root.querySelector('[data-pc-pb-stock]');
    var stockText = root.querySelector('[data-pc-pb-stock-text]');
    var form = root.querySelector('[data-pc-pb-form]');
    var formVariant = root.querySelector('[data-pc-pb-form-variant]');
    var formQuantity = root.querySelector('[data-pc-pb-form-quantity]');
    var add = root.querySelector('[data-pc-pb-add]');
    var addLabel = root.querySelector('[data-pc-pb-add-label]');
    var addPrice = root.querySelector('[data-pc-pb-add-price]');
    var status = root.querySelector('[data-pc-pb-status]');
    var whatsapp = root.querySelector('[data-pc-pb-whatsapp]');
    var shippingTitle = root.querySelector('[data-pc-pb-shipping-title]');
    var shippingText = root.querySelector('[data-pc-pb-shipping-text]');
    var sticky = root.querySelector('[data-pc-pb-sticky]');
    var stickyAdd = root.querySelector('[data-pc-pb-sticky-add]');
    var stickyPrice = root.querySelector('[data-pc-pb-sticky-price]');
    var stickyOffer = root.querySelector('[data-pc-pb-sticky-offer]');
    var buyZone = root.querySelector('[data-pc-pb-buy-zone]');
    var zoomModal = root.querySelector('[data-pc-pb-zoom-modal]');
    var zoomImage = root.querySelector('[data-pc-pb-zoom-image]');

    function showSlide(index) {
      if (!slides.length) return;
      var next = ((Number(index) % slides.length) + slides.length) % slides.length;
      activeSlide = next;
      slides.forEach(function (slide, i) {
        var active = i === next;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (!active) {
          slide.querySelectorAll('video').forEach(function (video) { try { video.pause(); } catch (error) {} });
        }
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === next;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (count) count.textContent = (next + 1) + ' / ' + slides.length;
      if (thumbs[next]) thumbs[next].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }

    function showMediaId(mediaId) {
      if (!mediaId) return;
      var target = slides.findIndex(function (slide) { return Number(slide.dataset.mediaId) === Number(mediaId); });
      if (target >= 0) showSlide(target);
    }

    function variantFromOptions() {
      return variants.find(function (variant) {
        if (!Array.isArray(variant.options) || variant.options.length !== selectedOptions.length) return false;
        return variant.options.every(function (value, index) { return String(value) === String(selectedOptions[index]); });
      }) || null;
    }

    function canBuyQuantity(variant, quantity) {
      if (!variant || !variant.available) return false;
      if (variant.inventoryManagement && String(variant.inventoryPolicy) !== 'continue') {
        return Number(variant.inventoryQuantity || 0) >= Number(quantity || 1);
      }
      return true;
    }

    function setStatus(message, type) {
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', type === 'error');
      status.classList.toggle('is-success', type === 'success');
    }

    function findById(id) {
      return variants.find(function (variant) { return Number(variant.id) === Number(id); }) || null;
    }

    function selectedItems(quantity) {
      var tier = quantity || selectedBundle;
      if (!bundleWrap || tier === 1) return currentVariant ? [currentVariant] : [];
      var startIndex = tier === 3 ? 2 : 0;
      return selectedBundleVariantIds.slice(startIndex,startIndex + tier).map(findById);
    }

    // Estimates only. Checkout must use matching native Shopify Buy X Get Y discounts.
    // Buy 2: 50% off the lower-priced belt. Buy 3: the lowest-priced of three is free.
    function bundlePrices(quantity) {
      var chosen = selectedItems(quantity);
      if (chosen.length !== quantity || chosen.some(function(v){return !v})) return { total: 0, compare: 0 };
      var prices = chosen.map(function(v){ return Number(v.price || 0); });
      var rawTotal = prices.reduce(function(sum,p){return sum+p;},0);
      var compareTotal = chosen.reduce(function(sum,v){return sum+Math.max(Number(v.compareAtPrice || 0),Number(v.price || 0));},0);
      var discount = 0;
      if (quantity === 2) discount = Math.round(Math.min.apply(null,prices) * discountPercent / 100);
      if (quantity === 3) discount = Math.min.apply(null,prices);
      return { total: rawTotal - discount, compare: compareTotal };
    }
    function currentTotal() { return bundlePrices(selectedBundle).total; }
    function currentCompareTotal() { return bundlePrices(selectedBundle).compare; }
    function canBuyBundle() {
      var chosen = selectedItems(selectedBundle);
      if (chosen.length !== selectedBundle || chosen.some(function(v){return !v})) return false;
      var grouped = new Map();
      chosen.forEach(function(v){ grouped.set(v.id,(grouped.get(v.id)||0)+1); });
      return Array.from(grouped).every(function(pair) { return canBuyQuantity(findById(pair[0]),pair[1]); });
    }
    function swatchColors(title) {
      var text = String(title || '').toLowerCase();
      var main = text.includes('black') ? '#171717' : text.includes('coffee') || text.includes('brown') ? '#654027' : text.includes('blue') || text.includes('navy') ? '#1E2B45' : text.includes('yellow') || text.includes('tan') || text.includes('beige') ? '#C5A17A' : '#A8A8A8';
      var buckle = text.includes('gunmetal') || text.includes('gun metal') ? '#44494D' : text.includes('gold') ? '#BD9558' : '#B8B8B8';
      return [main,buckle];
    }
    function updateBundleCards() {
      if (!bundleWrap) return;
      bundleWrap.dataset.offer = String(selectedBundle);
      root.dataset.pcPbOffer = String(selectedBundle);
      bundleCards.forEach(function(card) {
        var selected = Number(card.dataset.bundleQuantity) === selectedBundle;
        card.classList.toggle('is-selected',selected);
        card.setAttribute('aria-checked',selected ? 'true' : 'false');
        card.setAttribute('tabindex',selected ? '0' : '-1');
      });
      [1,2,3].forEach(function(quantity) {
        var totals = bundlePrices(quantity);
        var priceNode = bundleWrap.querySelector('[data-pc-pb-bundle-price="' + quantity + '"]');
        var compareNode = bundleWrap.querySelector('[data-pc-pb-bundle-compare="' + quantity + '"]');
        if (priceNode) priceNode.textContent = money(totals.total,config.currency);
        if (compareNode) {
          compareNode.textContent = money(totals.compare,config.currency);
          compareNode.hidden = totals.compare <= totals.total;
        }
      });
      bundleSelects.forEach(function(select,idx) {
        var variant = findById(select.value);
        var swatch = bundleWrap.querySelector('[data-pc-pb-swatch="' + idx + '"]');
        if (swatch && variant) {
          var colors = swatchColors(variant.title);
          swatch.style.setProperty('--q-swatch-a',colors[0]);
          swatch.style.setProperty('--q-swatch-b',colors[1]);
        }
      });
    }

    function updateStock() {
      if (!stock || !stockText || !currentVariant) return;
      var threshold = Math.max(1, Number(stock.dataset.threshold || 20));
      var managed = Boolean(currentVariant.inventoryManagement);
      var quantity = Number(currentVariant.inventoryQuantity || 0);
      var shouldShow = managed && String(currentVariant.inventoryPolicy) !== 'continue' && quantity > 0 && quantity <= threshold;
      stock.classList.toggle('is-hidden', !shouldShow);
      if (shouldShow) {
        var template = stock.dataset.template || 'Only {count} left in stock';
        stockText.textContent = template.replace('{count}', quantity);
      }
    }

    function updateShipping() {
      if (shippingTitle) shippingTitle.textContent = 'FREE WORLDWIDE SHIPPING';
      if (shippingText) shippingText.textContent = 'Complimentary tracked shipping on every order where configured at checkout.';
    }

    function updateWhatsapp() {
      if (!whatsapp || !config.whatsappNumber) return;
      var template = whatsapp.dataset.message || 'Hi Qeltro, I want to order {product}.';
      var message = template
        .replace('{product}', config.productTitle || 'Qeltro Automatic Buckle Belt')
        .replace('{quantity}', String(selectedQuantity))
        .replace('{price}', money(currentTotal(), config.currency));

      whatsapp.href = 'https://wa.me/' + config.whatsappNumber + '?text=' + encodeURIComponent(message);
    }

    function updatePurchaseState() {
      var total = currentTotal();
      var compareTotal = currentCompareTotal();
      var purchasable = canBuyBundle();
      selectedQuantity = selectedBundle;

      if (price) price.textContent = currentVariant ? money(currentVariant.price, config.currency) : '';
      if (compare) {
        var showCompare = currentVariant && Number(currentVariant.compareAtPrice || 0) > Number(currentVariant.price || 0);
        compare.classList.toggle('is-hidden', !showCompare);
        compare.textContent = showCompare ? money(currentVariant.compareAtPrice, config.currency) : '';
      }
      if (sale) {
        var showSale = currentVariant && Number(currentVariant.compareAtPrice || 0) > Number(currentVariant.price || 0);
        sale.classList.toggle('is-hidden', !showSale);
      }
      if (formVariant) formVariant.value = currentVariant ? currentVariant.id : '';
      if (formQuantity) formQuantity.value = selectedQuantity;
      if (add) add.disabled = !purchasable;
      if (stickyAdd) stickyAdd.disabled = !purchasable;
      if (addPrice) addPrice.textContent = money(total, config.currency);
      if (stickyPrice) stickyPrice.textContent = money(total, config.currency);
      if (stickyOffer) stickyOffer.textContent = 'Qeltro';
      if (addLabel) {
        var baseLabel = add ? (add.dataset.label || 'ADD TO CART') : 'ADD TO CART';
        if (!currentVariant) addLabel.textContent = 'UNAVAILABLE';
        else if (selectedBundle === 1 && !currentVariant.available) addLabel.textContent = 'SOLD OUT';
        else if (!purchasable) addLabel.textContent = 'NOT ENOUGH STOCK';
        else addLabel.textContent = baseLabel;
      }
      updateStock();
      updateBundleCards();
      updateShipping();
      updateWhatsapp();
      if (compareTotal > total) {
        root.dataset.pcPbSavingsCents = String(compareTotal - total);
      } else {
        root.dataset.pcPbSavingsCents = '0';
      }
    }

    function updateVariantButtons() {
      root.querySelectorAll('[data-pc-pb-option-value]').forEach(function (button) {
        var index = Number(button.dataset.optionIndex || 0);
        var active = String(selectedOptions[index]) === String(button.dataset.value || '');
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      root.querySelectorAll('[data-pc-pb-option-label]').forEach(function(label) {
        label.textContent = selectedOptions[Number(label.dataset.pcPbOptionLabel || 0)] || '';
      });
    }

    function selectVariantOption(button) {
      var index = Number(button.dataset.optionIndex || 0);
      selectedOptions[index] = String(button.dataset.value || '');
      currentVariant = variantFromOptions();
      // Carry the Buy 1 color into belt #1 when switching to a multi-belt offer.
      if (currentVariant && selectedBundle === 1) {
        [0,2].forEach(function(idx) {
          selectedBundleVariantIds[idx] = currentVariant.id;
          if (bundleSelects[idx]) bundleSelects[idx].value = String(currentVariant.id);
        });
      }
      updateVariantButtons();
      if (currentVariant && currentVariant.featuredMediaId) showMediaId(currentVariant.featuredMediaId);
      updatePurchaseState();
      if (currentVariant && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', currentVariant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    async function addToCart() {
      if (!canBuyBundle()) {
        setStatus('The selected belt option is unavailable or has insufficient stock.','error');
        return;
      }
      if (add) add.disabled = true;
      if (stickyAdd) stickyAdd.disabled = true;
      setStatus('Adding your belts to cart...', '');

      var items = [];
      // Group duplicate variants so Shopify respects inventory counts and line quantities.
      selectedItems(selectedBundle).forEach(function(v) {
        var found = items.find(function(item){ return item.id === Number(v.id); });
        if (found) found.quantity += 1;
        else items.push({ id:Number(v.id), quantity:1 });
      });
      try {
        var base = (config.routesRoot || '/').replace(/\/?$/, '/');
        var response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        });
        var payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add the selected belt.');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('qeltro:cart-open'));
        setStatus('Added to cart. Your bundle discount is applied at checkout.', 'success');
      } catch (error) {
        setStatus(error && error.message ? error.message : 'Unable to add to cart.', 'error');
      } finally {
        updatePurchaseState();
      }
    }

    var buyZoneInView = true;
    var drawerOpening = false;
    function isQeltroCartOpen() {
      return Boolean(document.querySelector('.q-cart-drawer.active, cart-drawer.active, cart-drawer.is-open, cart-drawer[aria-hidden="false"], .pc-cart-drawer.is-active, .pc-header.is-panel-open, body.pc-panel-open'));
    }
    function updateStickyVisibility() {
      if (!sticky) return;
      var drawerOpen = drawerOpening || isQeltroCartOpen();
      var shouldShow = !buyZoneInView && !drawerOpen;
      root.dataset.pcPbDrawerOpen = drawerOpen ? 'true' : 'false';
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function initAccordions() {
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      root.querySelectorAll('[data-pc-pb-accordion]').forEach(function (details) {
        var summary = details.querySelector('summary');
        var panel = details.querySelector('[data-pc-pb-accordion-panel]');
        if (!summary || !panel) return;

        panel.style.height = details.open ? 'auto' : '0px';
        panel.style.opacity = details.open ? '1' : '0';

        summary.addEventListener('click', function (event) {
          event.preventDefault();
          if (details.dataset.animating === 'true') return;

          if (reducedMotion.matches) {
            details.open = !details.open;
            panel.style.height = details.open ? 'auto' : '0px';
            panel.style.opacity = details.open ? '1' : '0';
            return;
          }

          details.dataset.animating = 'true';

          if (details.open) {
            panel.style.height = panel.scrollHeight + 'px';
            panel.style.opacity = '1';
            requestAnimationFrame(function () {
              panel.style.height = '0px';
              panel.style.opacity = '0';
            });

            var closeEnd = function (transitionEvent) {
              if (transitionEvent.propertyName !== 'height') return;
              details.open = false;
              details.dataset.animating = 'false';
              panel.removeEventListener('transitionend', closeEnd);
            };
            panel.addEventListener('transitionend', closeEnd);
          } else {
            details.open = true;
            panel.style.height = '0px';
            panel.style.opacity = '0';
            var targetHeight = panel.scrollHeight;
            requestAnimationFrame(function () {
              panel.style.height = targetHeight + 'px';
              panel.style.opacity = '1';
            });

            var openEnd = function (transitionEvent) {
              if (transitionEvent.propertyName !== 'height') return;
              panel.style.height = 'auto';
              details.dataset.animating = 'false';
              panel.removeEventListener('transitionend', openEnd);
            };
            panel.addEventListener('transitionend', openEnd);
          }
        }, { signal: signal });
      });
    }

    function initReviewCarousels() {
      root.querySelectorAll('[data-pc-pb-reviews]').forEach(function (carousel) {
        var track = carousel.querySelector('[data-pc-pb-review-track]');
        var cards = Array.from(carousel.querySelectorAll('[data-pc-pb-review-card]'));
        var prev = carousel.querySelector('[data-pc-pb-review-prev]');
        var next = carousel.querySelector('[data-pc-pb-review-next]');
        var dotsWrap = carousel.querySelector('[data-pc-pb-review-dots]');
        if (!track || !cards.length) return;

        var activeIndex = 0;
        var rafId = 0;
        var dots = [];

        function cardLeft(index) {
          var card = cards[index];
          if (!card) return 0;
          return card.offsetLeft - track.offsetLeft;
        }

        function goTo(index) {
          var nextIndex = Math.max(0, Math.min(cards.length - 1, Number(index) || 0));
          activeIndex = nextIndex;
          track.scrollTo({ left: cardLeft(nextIndex), behavior: 'smooth' });
          updateDots();
        }

        function updateDots() {
          dots.forEach(function (dot, index) {
            var active = index === activeIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
        }

        function syncIndex() {
          if (!cards.length) return;
          var currentLeft = track.scrollLeft;
          var nearest = 0;
          var nearestDistance = Infinity;
          cards.forEach(function (card, index) {
            var distance = Math.abs((card.offsetLeft - track.offsetLeft) - currentLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearest = index;
            }
          });
          activeIndex = nearest;
          updateDots();
        }

        if (dotsWrap && cards.length > 1) {
          cards.forEach(function (card, index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', 'Go to review ' + (index + 1));
            dot.addEventListener('click', function () { goTo(index); }, { signal: signal });
            dotsWrap.appendChild(dot);
            dots.push(dot);
          });
          updateDots();
        }

        if (prev) prev.addEventListener('click', function () { goTo(activeIndex - 1); }, { signal: signal });
        if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); }, { signal: signal });

        track.addEventListener('scroll', function () {
          if (rafId) cancelAnimationFrame(rafId);
          rafId = requestAnimationFrame(syncIndex);
        }, { signal: signal, passive: true });

        signal.addEventListener('abort', function () {
          if (rafId) cancelAnimationFrame(rafId);
        }, { once: true });
      });
    }

    initAccordions();
    initReviewCarousels();

    updatePurchaseState();

    root.querySelector('[data-pc-pb-prev]')?.addEventListener('click', function () { showSlide(activeSlide - 1); }, { signal: signal });
    root.querySelector('[data-pc-pb-next]')?.addEventListener('click', function () { showSlide(activeSlide + 1); }, { signal: signal });
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { showSlide(Number(thumb.dataset.index || 0)); }, { signal: signal }); });
    root.querySelectorAll('[data-pc-pb-option-value]').forEach(function (button) { button.addEventListener('click', function () { selectVariantOption(button); }, { signal: signal }); });
    bundleCards.forEach(function (card) {
      function choose() { selectedBundle = Number(card.dataset.bundleQuantity || 1); updatePurchaseState(); }
      card.addEventListener('click', function(event) { if (event.target.closest('select')) return; choose(); }, { signal: signal });
      card.addEventListener('keydown', function(event) {
        if (event.target.closest('select, input, button')) return;
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(); }
      }, { signal: signal });
    });
    bundleSelects.forEach(function(select,idx) {
      select.addEventListener('click', function(event) { event.stopPropagation(); }, { signal: signal });
      select.addEventListener('change', function() {
        selectedBundleVariantIds[idx] = Number(select.value);
        selectedBundle = idx >= 2 ? 3 : 2;
        updatePurchaseState();
      }, { signal: signal });
    });

    if (slidesWrap) {
      var startX = null;
      slidesWrap.addEventListener('pointerdown', function (event) { startX = event.clientX; }, { signal: signal });
      slidesWrap.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        showSlide(activeSlide + (delta < 0 ? 1 : -1));
      }, { signal: signal });
      slidesWrap.addEventListener('pointercancel', function () { startX = null; }, { signal: signal });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart();
      }, { signal: signal });
    }

    if (stickyAdd) stickyAdd.addEventListener('click', addToCart, { signal: signal });

    root.querySelectorAll('[data-pc-pb-zoom]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (!zoomModal || !zoomImage) return;
        zoomImage.src = trigger.dataset.zoomSrc || '';
        zoomModal.classList.add('is-active');
        zoomModal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }, { signal: signal });
    });

    function closeZoom() {
      if (!zoomModal) return;
      zoomModal.classList.remove('is-active');
      zoomModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    root.querySelector('[data-pc-pb-zoom-close]')?.addEventListener('click', closeZoom, { signal: signal });
    if (zoomModal) zoomModal.addEventListener('click', function (event) { if (event.target === zoomModal) closeZoom(); }, { signal: signal });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeZoom(); }, { signal: signal });

    if (sticky && buyZone && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        buyZoneInView = entries[0] ? entries[0].isIntersecting : true;
        updateStickyVisibility();
      }, { threshold: .15 });
      observer.observe(buyZone);
      signal.addEventListener('abort', function () { observer.disconnect(); }, { once: true });
    }

    if (sticky) {
      // Hide immediately, even while the Ajax drawer is still fetching cart contents.
      document.addEventListener('qeltro:cart-open', function () {
        drawerOpening = true;
        updateStickyVisibility();
      }, { signal: signal });
      document.addEventListener('qeltro:cart-close', function () {
        drawerOpening = false;
        updateStickyVisibility();
      }, { signal: signal });
    }
    if (sticky && 'MutationObserver' in window) {
      // Watch the actual current Qeltro cart element as well as older compatible cart panels.
      var panelNodes = document.querySelectorAll('.q-cart-drawer, cart-drawer, .pc-header, .pc-cart-drawer, .pc-menu-drawer, .pc-search');
      var mutationObserver = new MutationObserver(function () {
        // The drawer opening flag can clear once a real active/closed state is observed.
        if (isQeltroCartOpen()) drawerOpening = false;
        else if (panelNodes.some(function(panel){ return panel.matches('.q-cart-drawer, cart-drawer'); })) drawerOpening = false;
        updateStickyVisibility();
      });
      panelNodes.forEach(function (panel) {
        mutationObserver.observe(panel, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
      });
      mutationObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      signal.addEventListener('abort', function () { mutationObserver.disconnect(); }, { once: true });
    }
    updateStickyVisibility();
  }

  function initAll(scope) {
    var parent = scope || document;
    if (parent.matches && parent.matches('[data-pc-product-builder]')) initBuilder(parent);
    if (parent.querySelectorAll) parent.querySelectorAll('[data-pc-product-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  if (!window.__pcProductBuilderLifecycleBound) {
    window.__pcProductBuilderLifecycleBound = true;
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target && event.target.querySelector ? event.target.querySelector('[data-pc-product-builder]') : null;
      if (!root && event.target && event.target.matches && event.target.matches('[data-pc-product-builder]')) root = event.target;
      if (root && root._pcPbController) root._pcPbController.abort();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
